import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { SaveGQuotationRequest } from 'src/app/viewmodels/g-quotation/QuotationModel';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.scss']
})
export class QuotationComponent implements OnInit {

  public SortBy: string = "asc";
  public modalRef: BsModalRef;
  public itemVm: SaveGQuotationRequest;
  public attachmentList: any = [];
  public vmListItems: SaveGQuotationRequest[] = [];
  dataTable: any;
  @Input('dataTable') table;
  dtOption: any = {};
  public client: any;

  p = 1; // current page
  size = 10; // records per page
  totalItems = 0;
  searchTerm = '';
  orderBy = 'Id';
  sort = 'Desc';
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private spinner: NgxSpinnerService,
    private _localStorageService: LocalStorageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.client = this._localStorageService.get("com");
    this.getList();
    $('table.display').DataTable();
    // this.dtOption = {
    //   "paging": false,
    //   "searching": false,
    //   "info": false,
    // };
    // $(() => {
    //   $('table.display').DataTable(this.dtOption);
    // })
  }

  getList() {
    this.spinner.show();
    debugger
    const search = { Name: this.searchTerm }; // adapt per page
    this._uow.gSaleService.getList("GSale", "GetGQuotationAsync", this.p, this.size, search, this.orderBy, this.sort)
      .subscribe({
        next: (res: any) => {
          debugger
          this.vmListItems = res.result;
          this.totalItems = res.total;
          this.spinner.hide();
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
        }
      });
  }

  // called when user types in search box
  getBySearchTerm(event: any) {
    debugger
    this.searchTerm = event.target.value.trim();
    this.p = 1; // reset to first page
    this.getList();
  }

  // pagination handler
  onPageChange(page: number) {
    debugger
    this.p = page;
    this.getList();
  }

  // sorting handler (toggle Asc/Desc)
  getSortIndexList(column: string) {
    this.orderBy = column;
    this.sort = this.sort === 'Asc' ? 'Desc' : 'Asc';
    this.getList();
  }


  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-lg');
  }

  EditQuotation(e) {
    this.router.navigate(['/edit-quotation', e]);
  }

  // extrnal components
  onItemSubmitted(e) {
    document.location.reload();
    console.log(e);
    if (e === true) {
      //this.itemVm = new G_PurchaseMasterViewModel();
      this.getList();
    }
  }

  public deleteId: string;
  openDeleteModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this.spinner.show();
    this._uow.gSaleService.DeleteGQuotationAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRef.hide();
      this.spinner.hide();
    }, (err) => {
      this._jq.showSpinner();
      this.spinner.hide();
    });
  }

 openAttachmentModal(template: TemplateRef<any>, b: number) {
  debugger;

  const selectedItem = this.vmListItems.find(x => x.id === b);

  this.attachmentList = selectedItem
    ? selectedItem.gQuotationAttachments.map(att => att.attachment)
    : [];

  this.modalRef = this._uow.modalServiceEx.show(template);
  this.modalRef.setClass('modal-lg');
}

  public pdfUrl: string;
  openPdfModel(template: TemplateRef<any>, model?) {
    debugger
    this.pdfUrl = `https://garagedesks.s3.eu-central-1.amazonaws.com/${model.attachment}`;
    this.modalRef = this._uow.modalServiceEx.show(template);
    this.modalRef.setClass('modal-xl');
    
  }

}
